<template>
	<div>
		<div class="tw-text-[32px] tw-font-bold" style="line-height: 1">
			{{ $t('integrations.link-your-salla-marketplace') }}
		</div>
		<div class="tw-text-2xl tw-font-medium tw-text-gray-500">
			{{ $t('integrations.install-linker-app-on-your-salla-marketplace') }}
		</div>
		<div class="tw-mt-11">
			<div class="tw-flex tw-flex-col tw-gap-6">
				<div class="tw-border-b tw-border-gray-300 tw-pb-6">
					<p class="tw-px-2 tw-text-xl">
						<span>1. </span>
						<span>
							{{ $t('integrations.visit-salla-app-store-on-your-account-here') }}
						</span>
						<span class="tw-px-1 tw-text-blue-500 tw-underline">
							<a href="https://apps.salla.sa/ar/app/162406454">{{
								$t('integrations.here')
							}}</a>
						</span>
					</p>
				</div>
				<div class="tw-border-b tw-border-gray-300 tw-pb-6">
					<p class="tw-px-2 tw-pb-1 tw-text-xl">
						2. {{ $t('integrations.after-logging-into-your-account-add-app') }}
					</p>
					<AppImage src="/assets/v2/image/salla/install-app/step-2.webp" alt="Add App" />
				</div>
				<div class="tw-border-b tw-border-gray-300 tw-pb-6">
					<p class="tw-px-2 tw-pb-1 tw-text-xl">
						3. {{ $t('integrations.click-approve-permissions') }}
					</p>
					<AppImage
						src="/assets/v2/image/salla/install-app/step-3.webp"
						alt="Approve Permissions"
					/>
				</div>
				<div>
					<p class="tw-px-2 tw-pb-1 tw-text-xl">
						4. {{ $t('integrations.select-yes-input-email-click-save') }}
					</p>
					<AppImage
						src="/assets/v2/image/salla/install-app/step-4.webp"
						alt="Input Email and Save"
					/>
				</div>
			</div>
			<div class="tw-mt-5">
				<AppButton
					:label="$t('integrations.next-step')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
					@click="nextStep"
					:loading="nextStepLoading"
					:disabled="!isDone"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { marketplaceStepStatusEnum } from '../../helper';

const linkMarketplaceStore = useLinkMarketplaceStore();
const nextStepLoading = ref(false);

const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);

const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped>
/* Add any additional styles here */
</style>
